import React, { JSX }  from "react";


import { Col, Row } from "react-bootstrap";


import SectionContainerComponent from "@Components/Sections/SectionContainer";


import "./index.scss";


type BottomSectionComponentProps = {
    sectionName: string;
    sectionHeaderText?: string;
    sectionSubText?: string;
    children?: React.ReactNode;
};


export const BottomSectionComponent:React.FC<BottomSectionComponentProps> = ({
    sectionName,
    sectionHeaderText, sectionSubText,
    children,
}) => {


    return (
        <SectionContainerComponent id={`${sectionName}__page-bottom-section page-bottom-section`}>

            <Col xs={12} className={`${sectionName}-page-bottom-section__section-content page-bottom-section__section-head`}>
                <Row className={`${sectionName}__page-bottom-section__section-content__content page-bottom-section__section-head__content`}>
                    {sectionHeaderText &&
                    <Col xs={12} className={`${sectionName}__page-bottom-section__section-content__header page-bottom-section__section-head__header`}>
                        <span>{sectionHeaderText}</span>
                    </Col>
                    }
                    {sectionSubText &&
                    <Col xs={12} className={`${sectionName}__page-bottom-section__section-content__text page-bottom-section__section-head__text`}>
                        <span>{sectionSubText}</span>
                    </Col>
                    }
                </Row>
            </Col>

            {children &&
            <Col xs={12} className={`${sectionName}__page-bottom-section__section-content page-bottom-section__section-content`}>
                <Row className={`${sectionName}__page-bottom-section__section-content__content page-bottom-section__section-content__content`}>
                    {children}
                </Row>
            </Col>
            }

        </SectionContainerComponent>
    );

};


export default BottomSectionComponent;
